import * as Rx from 'rxjs/Rx'

const animationFrame: Rx.Observable<number> = Rx.Observable
  .create((observer: Rx.Observer<void>) => {
    let request: number = requestAnimationFrame(step)
    function step () {
      observer.next(undefined)
      request = requestAnimationFrame(step)
    }
    return () => {
      cancelAnimationFrame(request)
    }
  })
  .timeInterval()
  .pluck('interval')

export default animationFrame



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/animationFrame.ts